<!-- header.component.html -->

<!-- *ngIf="!isMobileDevice -->
<nav
  class="navbar fixed-top navbar-toggleable-md navbar-expand-lg d-flex justify-content-between"
  [ngClass]="{ 'home-page': isHomePage, 'no-padding': hideButton }"
>
<div class="container">
  <div class="logo-outer d-flex align-items-center">
    <button
      class="btn d-flex"
      *ngIf="isHomePage; else otherPagesHamburger"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#sidebar"
      aria-controls="sidebar"
     
    >
      <i class="fa-solid fa-bars"></i>
    </button>

    <!-- For other pages: show hamburger only on mobile/tablet -->
    <ng-template #otherPagesHamburger>
      <button
        class="btn d-flex d-lg-none"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#sidebar"
        aria-controls="sidebar"
        [ngClass]="{ 'd-none': isPromotionPage && isMobileDevice}"
      >
        <i class="fa-solid fa-bars"></i>
      </button>
    </ng-template>

    <div class="ml-2">
      <a href="">
        <img
          src="https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/kisan-logo.png"
          alt="kisan logo"
          height="48"
        />
      </a>
    </div>
  </div>

  


  <div class="d-flex align-items-center gap-3 languageMenu" >
    <div class="dropdown" [class.open]="isOpen" *ngIf="isPromotionPage">
      <button  (click)="toggleDropdown()">
       <img src="assets/images/lang-icon.png" alt="Language Flag" />
      </button>

      <ul class="menu">
        <li [class.active]="promotionCurrentLang === 'mr'" ><a (click)="switchLanguage('mr')" >Marathi</a></li>
        <li [class.active]="promotionCurrentLang === 'en'"><a (click)="switchLanguage('en')" >English</a></li>
      </ul>
    </div>
   
      <div id="google_translate_element" class="google-translate-dropdown" *ngIf="!hideButton" ></div>
   

    <button class="btn btn-login" (click)="onLogin()" *ngIf="!isAuthenticated">
      <i class="fa-solid fa-arrow-right arrow"></i>
      <span>Log in/Sign up</span>
    </button>
  </div>
  
  </div>
</nav>
